import Chart from 'core/chart';
import { HIGHCHARTS_DATE_TIME_LABEL_FORMATS } from 'utils/chart';
import { deepMerge } from 'utils/helpers';
import { PERCENTAGE_TYPE } from 'utils/metrics';
import { getTheme } from 'utils/themes';
import { getTimeZoneOffsetValue } from 'utils/timeZone';
import { getTimeZone } from 'utils/userContext';
import { rowHeight } from 'modules/dashboard/utils/dashboardUtils';
import {
  getWidgetMetric,
  getWidgetSettings,
  getWidgetVisualization,
} from 'modules/dashboard/utils/dashboardWidgetUtils';
import { DashboardMetricWidgetCssWrapper } from '../../Dashboard.styled';

// type Props = {
//   data: {},
//   /** If the widget is currently lodaing. */
//   isLoading: boolean,
//   /** Dashboard panel layout data. */
//   layout: {},
//   /** Settings of the widget containing visualization and metric. */
//   settings: {},
//   /** Theme of the widget. */
//   theme: string,
//   /** The user context object. */
//   userContext: {},
//   /** Widget config data. */
//   widget: {},
// };

const defaultProps = {
  layout: {},
};

const MetricWidget = (props) => {
  const { data, isLoading, layout, theme, userContext, widget, ...chartProps } = props;
  const metric = getWidgetMetric(widget);
  const settings = getWidgetSettings(widget);
  const visualization = getWidgetVisualization(widget);
  const ChartType = Chart.getChartType(visualization) || Chart.getChartType('line');
  const themeDef = getTheme(theme);
  const timeZone = getTimeZone(userContext);
  const timeZoneOffset = getTimeZoneOffsetValue(timeZone, new Date());

  /**
   * getChartHeight
   * Adjusts chart height based on showing table.
   * @param { Number } height: Height of the dashboardPanel.
   * @param { Number } width: Width of the dashboardPanel.
   * @returns { Number } chart height in pixels.
   */
  const getChartHeight = (height, width) => {
    const widgetTitleHeight = 40;
    const widgetPadding = 20;
    const numberOfPadding = height - 1;
    const calculatedChartHeight = height * rowHeight;
    const calculatedChartPadding = numberOfPadding * widgetPadding;
    const totalCalculatedChartHeight = calculatedChartHeight + calculatedChartPadding;
    const chartHeight = totalCalculatedChartHeight - width;
    return chartHeight - widgetTitleHeight;
  };

  const chartOptions = deepMerge(
    {
      chart: {
        height: getChartHeight(layout.h, layout.w),
      },
      isPercent: metric && metric.displayType === PERCENTAGE_TYPE,
      legend: {
        enabled: !isLoading,
        itemStyle: {
          color: themeDef.legendTextColor,
          fontWeight: themeDef.legendFontWeight,
        },
        itemHiddenStyle: {
          color: themeDef.legendTextColorDisabled,
        },
        itemHoverStyle: {
          color: themeDef.legendTextColorHover,
        },
      },
      series: {
        marker: {
          radius: 0.2,
          states: {
            hover: {
              radius: 4,
              radiusPlus: 0,
            },
          },
        },
        states: {
          hover: {
            lineWidthPlus: 0,
          },
        },
      },
      time: {
        timezoneOffset: timeZoneOffset,
      },
      xAxis: {
        type: 'datetime',
        dateTimeLabelFormats: HIGHCHARTS_DATE_TIME_LABEL_FORMATS,
      },
    },
    settings,
  );

  return (
    <DashboardMetricWidgetCssWrapper data-invert={settings?.invertColors === 1}>
      <ChartType
        key="widgetChart"
        className="chart cssMetricWidgetChart"
        options={chartOptions}
        theme={theme}
        {...chartProps}
        {...data}
      />
    </DashboardMetricWidgetCssWrapper>
  );
};

export default MetricWidget;
MetricWidget.defaultProps = defaultProps;
